<template>
  <svg class="spinner icon-md text-white fill-current"><use xlink:href="/assets/icons.svg#spinner" /></svg>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style lang="scss" scoped>
.spinner {
  animation: spin 2s infinite linear;
}
</style>
